import React, { useState, useEffect, useRef } from 'react';
import { Container, Box, Typography, Button } from '@mui/material';
import Layout from '../../components/Layout';
import Heading from '../../components/Heading';
import useWindowDimensions from '../../dimension';
import SearchBar from '../../components/SearchBar';
// assets
import imgPlus from '../../assets/images/plus.png';
import imgMinus from '../../assets/images/minus.png';
import imgLine from '../../assets/images/line.png';

const data = [
  {
    title: `What is Thor Financial?`,
    para: `Thor Financial is an ever-growing and expanding ecosystem; our beginnings are rooted in
    the passive income, Nodes-as-a-Service/DeFi-as-a-Service space, but have now grown to
    include Metaverse, a native NFT marketplace, Play2Earn and further components to our
    service.`,
  },
  {
    title: `Is Thor a fork or entirely its own code?`,
    para: `Whilst originally forking our code, we now have a fully fledged V2 contract which is entirely
    custom written, to include such functions as a sliding tax, node fees, node renaming,
    staking and lottery systems`,
  },
  {
    title: `What investments has Thor made?`,
    para: `Our full list of investments, including blue chips, validator nodes and more, can be found on
    [insert investment page link].`,
  },
  {
    title: `Is the Thor team KYCd?`,
    para: (
      <>
        We are indeed KYCd; namely, our project founder and main developer, Heimdall, submitted his sensitive biometric
        information to Assure DeFi. The link can be found here. (hyperlink the word “here” with the following link -
        <a href=" https://www.assuredefi.io/projects/thor-financial" target="_blank">
          {' '}
          https://www.assuredefi.io/projects/thor-financial
        </a>
        )
        <br />
        Outside of Heimdall, our Community Manager (Colin) & Human Resources Director (Arin) are doxxed and a number of
        additional core team members/staff have revealed their faces & names openly
      </>
    ),
  },
  {
    title: `What does it mean to compound a node?`,
    para: `To compound a node simply means to use the rewards earned from a node to create a new
    node.
    `,
  },
  {
    title: `Can I use rewards from my wallet to make
    up the difference I am short rewards?`,
    para: `Referred to as the Quality of Life feature (QoL), as long as you have at least 50% in
    unclaimed rewards the rest of the cost can come from your wallet.
    `,
  },
  {
    title: `Are there any taxes associated with this project?`,
    para: (
      <>
        There are indeed; we have a sliding tax system, which taxes you upon claiming. The numbers are as follows:
        <br />
        <br />
        <ul>
          <li>Node Creation + 0 - 7 days = 50% Tax</li>
          <li>Node Creation + 8 - 14 days = 40% Tax</li>
          <li>Node Creation + 15 - 21 days = 30% Tax</li>
          <li>Node Creation + 22 - 27 days = 20% Tax</li>
        </ul>
        <br />
        <br />
        Then, the values drop to the following per node type:
        <ul>
          <li>ODIN Node Creation + 28+ days = 10% Tax</li>
          <li>THOR Node Creation + 28+ days = 8% Tax</li>
          <li>FREYA Node Creation + 28+ days = 5% Tax</li>
          <li>HEIMDALL Node Creation + 28+ days = 1% Tax</li>
        </ul>
      </>
    ),
  },
  {
    title: `Will a node cap be instituted?`,
    para: `Yes; we will begin by capping the creation of Heimdalls, then Freyas shortly after; then
    Thors and finally Odins. No dates have been set.`,
  },
  {
    title: `Is there a limit to node creation per wallet?`,
    para: `As of the V2 updates, an unlimited amount of nodes can be created per wallet.
    `,
  },
  {
    title: `What is the contract address of the $Thor token?`,
    para: `0x8f47416cae600bccf9530e9f3aeaa06bdd1caa79`,
  },
  {
    title: `Where can I purchase $Thor?`,
    para: (
      <>
        You can purchase $Thor from the TraderJoe:{' '}
        <a href="https://traderjoexyz.com/trade" target="_blank">
          https://traderjoexyz.com/trade
        </a>{' '}
        Simply type in “Thor” and the token will populate.
      </>
    ),
  },
  {
    title: `With which wallets is Thor’s DApp compatible?`,
    para: `We strongly recommend using MetaMask as it causes the least issues; however, you can
    use Coinbase Wallet and WalletConnect.`,
  },
  {
    title: `Does Thor have an OTC service?`,
    para: (
      <>
        We do have an OTC service; presently, this can be located within the Discord. Effectively, Loki holds an escrow
        wallet, through which the buyer and seller’s funds are exchanged, which are subsequently sent to the respective
        parties, after both parties have agreed to terms (payment token, agreed token price, e.t.c.).
        <br />
        We are working to outsource to a professional OTC service which will automate the process.
      </>
    ),
  },
  {
    title: `Does Thor Financial host regular AMAs?`,
    para: (
      <>
        Indeed, we do; these occur at 5PM PST on Thorsdays, within our Discord server and also on our Twitch channel,
        which can be located here. (hyperlink the word “here” with the following link -{' '}
        <a href=" https://www.twitch.tv/thorfinancial" target="_blank">
          {' '}
          https://www.twitch.tv/thorfinancial).
        </a>
      </>
    ),
  },
  {
    title: `Do my nodes have fees associated with them?`,
    para: (
      <>
        That is correct; see below for more information:
        <br />
        <ul>
          <li>Odin $40 per month</li>
          <li>Thor $10 per month</li>
          <li>Freya $4 per month</li>
          <li>Heimdall $1 per month</li>
        </ul>
        Please note that these fees are subject to change, based on $THORs market price. If your fee is left unpaid, the
        pending rewards of that node are forfeited; at this point, the node is indefinitely inactive, until the amount
        due in fees is repaid, plus an activation fee—the node will not accrue rewards. The reactivation fee is equal to
        the monthly maintenance fee of the node (E.G., if a Thor node was to lapse, it would cost $20 for the unpaid
        maintenance fee, and an additional $20 to reactivate).
        <br />
        The long term plan with fees is to base all node maintenance fees on the market action & price of Thor.
        <br />
        <br />
        Are fees taken from unclaimed rewards?
        <br />
        Fees are paid in AVAX. The reason that fees are payable in Avax and not Thor, is because if we collected the
        fees in Thor, at some point we would have to sell the token, causing mass sell pressure.
        <br />
        The fees are due 30 days from point of node creation
        <br />
        Please keep in mind, the button REMAINS even after you've paid. If you've paid once, please scroll down to the
        individual nodes section, and you will see that the date has been moved forward; that's how you can confirm the
        payment has gone through!
      </>
    ),
  },
  {
    title: `What social media platforms does Thor Financial participate in?`,
    para: (
      <>
        Thor Financial participates in the following social media and online services.
        <br />
        <ul>
          <li>Medium {'->'} link to medium</li>
          <li>Twitter {'->'} link to twitter</li>
          <li>Discord {'->'} invite to discord</li>
        </ul>
        <br />
        Please note, Thor Financial does not have an official Telegram group. If you are part of a group within
        Telegram, it is probably a scam.
      </>
    ),
  },
  {
    title: `What if my wallet is compromised? What can I do?`,
    para: (
      <>
        Unfortunately, Thor Financial cannot fix your compromised wallet. This is why it is so important to take
        security seriously. We have compiled information on wallet security within our discord server that you may
        review. To help make sure your wallet is never compromised, never give out your seed phrase.
        <br />
        If your wallet has been compromised, please open a Zendesk ticket giving us your wallet address and Discord id.
        We will contact you prior to your nodes becoming NFTs giving you time to prepare to transfer your nodes to an
        uncompromised wallet. In the meantime, you may acquire the services of a White Hacker to help facilitate keeping
        your nodes active and safe. As an alternative, you may let your nodes go inactive until they can be transferred
        to an uncompromised wallet. If you choose to let your nodes go inactive, all past due fees and a reactivation
        fee will be required for your nodes/NFTs to start producing rewards again.
      </>
    ),
  },
];

const fixesData = [
  {
    title: `I’m seeing MetaMask quote an unusually high gas fee, what should I do?`,
    para: `Making sure you have enough Avax to cover the “maximum fee” shown in MetaMask is
  necessary, otherwise MetaMask will quote an exorbitantly high gas fee`,
  },
  {
    title: `My DApp is showing an incorrect due date for my fees, what should I do?`,
    para: (
      <>
        Be sure to press CTRL + SHIFT + R whilst being on the DApp, and clear your browser’s cache + cookies. If the
        error persists, please contact our support (word “support” hyperlinked with link to our Zendesk{' '}
        <a href="https://thorfinancial.zendesk.com/hc/en-us" target="_blank">
          {' '}
          https://thorfinancial.zendesk.com/hc/en-us
        </a>
        .
      </>
    ),
  },
  {
    title: `I am experiencing issues with claiming, staking and/or paying for my nodes’ monthly
    maintenance fees, what should I do?`,
    para: ` If you are on phone, we strongly recommend using MetaMask on PC to try the
    transaction; if the error persists on PC, we recommend manually editing the gas and setting
    a higher priority and a higher GWEI value, as when Avax is congested, transactions can
    take longer to go through.`,
  },
  {
    title: `When I add to my staking position in either the SSS or the LP, my currently staked
    $THOR disappears. Why is this?`,
    para: `The SSS and LP both function such that when any additional amount of $THOR is
    staked, the amount currently being staked is auto-claimed into your MetaMask wallet; the
    $THOR does not disappear, it is simply moved to your MetaMask.
    `,
  },
];

const Faq = () => {
  const [activeTab, setActiveTab] = useState([
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ]);
  const [inputState, setInputState] = useState({
    search1: '',
    search2: '',
  });

  const [activeFixes, setActiveFixes] = useState([false, false, false, false]);
  const { width } = useWindowDimensions();

  const searchChangeHandler = (e) => {
    const { name, value } = e.target;

    setInputState((prevState) => {
      return {
        ...prevState,
        [name]: value,
      };
    });
  };

  const handleAccordion = (i) => {
    setActiveTab((prev) => {
      let arr = [...prev];
      let newArr = arr.map((elem, key) => {
        if (key == i) {
          return !elem;
        }
      });
      return newArr;
    });
  };

  const handleFixesAccordion = (i) => {
    setActiveFixes((prev) => {
      let arr = [...prev];
      let newArr = arr.map((elem, key) => {
        if (key == i) {
          return !elem;
        }
      });
      return newArr;
    });
  };

  useEffect(() => {
    setInputState({
      search1: '',
      search2: '',
    });
  }, []);

  useEffect(() => {
    data.forEach((el) => {
      el.hide = true;

      if (el.title.toLowerCase().includes(inputState.search1.toLowerCase())) {
        el.hide = false;
      }
    });

    fixesData.forEach((el) => {
      el.hide = true;

      if (el.title.toLowerCase().includes(inputState.search2.toLowerCase())) {
        el.hide = false;
      }
    });
  }, [inputState]);

  return (
    <Layout>
      <Heading title={'faq'} />

      <Container maxWidth="md" className="main_content_wrap">
        {/* <InputSearch /> */}
        <SearchBar
          value={inputState.search1}
          name="search1"
          onChange={searchChangeHandler}
          placeholder={'Enter search term...'}
        />

        <Box marginTop={6}>
          {data.map((v, i) => {
            if (v.hide) {
              return <></>;
            }
            return (
              <Box marginBottom={'5px'} key={i}>
                <Button
                  sx={{
                    width: '100%',
                    height: 'max-content',
                    background:
                      activeTab[i] == true
                        ? 'rgba(39, 47, 80, 0.5)'
                        : 'linear-gradient(92.91deg, rgba(19, 22, 30, 0.76) 1.78%, rgba(19, 22, 30, 0.62) 99.64%)',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '20px !important',
                    borderRadius: 0,
                  }}
                  onClick={() => handleAccordion(i)}
                >
                  <Typography
                    sx={{
                      fontSize: width > 700 ? '16px' : '14px',
                      color: 'white',
                      fontFamily: 'Kanit',
                      textAlign: 'left',
                    }}
                    textTransform="none"
                  >
                    {v.title}
                  </Typography>
                  {activeTab[i] == true ? <img src={imgMinus} /> : <img src={imgPlus} width={'24px'} height="24px" />}
                </Button>
                {activeTab[i] == true ? (
                  <Box
                    sx={{
                      lineHeight: '20px',
                      background: 'rgba(39, 47, 80, 0.5)',
                      filter: 'drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.48))',
                      boxShadow: '0px 4px 4px 0px #0000007A',
                      paddingX: '50px',
                      paddingY: '30px',
                      display: 'flex',
                    }}
                  >
                    <Box>
                      <img src={imgLine} alt="faq line" width="3px" height={'100%'} />
                    </Box>
                    <Box marginLeft={2}>
                      <Typography
                        sx={{
                          fontFamily: 'Kanit',
                          fontStyle: 'italic',
                          fontWeight: '300',
                          color: 'rgba(255, 255, 255, 0.6)',
                          fontSize: width > 700 ? '16px' : '14px',
                          textAlign: 'left',
                        }}
                      >
                        {v.para}
                      </Typography>
                    </Box>
                  </Box>
                ) : null}
              </Box>
            );
          })}
        </Box>
      </Container>
      <Box marginTop={6} marginBottom={6}>
        <Heading title={'Common fixes for glitches/errors:'} />
      </Box>
      <Container maxWidth="md" className="main_content_wrap">
        {/* <InputSearch /> */}
        <SearchBar
          value={inputState.search2}
          name="search2"
          onChange={searchChangeHandler}
          placeholder={'Enter search term...'}
        />

        <Box marginTop={6}>
          {fixesData.map((v, i) => {
            if (v.hide) {
              return <></>;
            }
            return (
              <Box marginBottom={'5px'} key={i}>
                <Button
                  sx={{
                    width: '100%',
                    height: 'max-content',
                    background:
                      activeFixes[i] == true
                        ? 'rgba(39, 47, 80, 0.5)'
                        : 'linear-gradient(92.91deg, rgba(19, 22, 30, 0.76) 1.78%, rgba(19, 22, 30, 0.62) 99.64%)',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '20px !important',
                    borderRadius: 0,
                  }}
                  onClick={() => handleFixesAccordion(i)}
                >
                  <Typography
                    sx={{
                      fontSize: width > 700 ? '16px' : '14px',
                      color: 'white',
                      fontFamily: 'Kanit',
                      textAlign: 'left',
                    }}
                    textTransform="none"
                  >
                    {v.title}
                  </Typography>
                  {activeFixes[i] == true ? <img src={imgMinus} /> : <img src={imgPlus} width={'24px'} height="24px" />}
                </Button>
                {activeFixes[i] == true ? (
                  <Box
                    sx={{
                      lineHeight: '20px',
                      background: 'rgba(39, 47, 80, 0.5)',
                      paddingX: '50px',
                      filter: 'drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.48))',
                      boxShadow: '0px 4px 4px 0px #0000007A',
                      paddingY: '30px',
                      display: 'flex',
                    }}
                  >
                    <Box>
                      <img src={imgLine} alt="faq line" width="3px" height={'100%'} />
                    </Box>
                    <Box marginLeft={2}>
                      <Typography
                        sx={{
                          fontFamily: 'Kanit',
                          fontStyle: 'italic',
                          fontWeight: '300',
                          color: 'rgba(255, 255, 255, 0.6)',
                          fontSize: width > 700 ? '16px' : '14px',
                          textAlign: 'left',
                        }}
                      >
                        {v.para}
                      </Typography>
                    </Box>
                  </Box>
                ) : null}
              </Box>
            );
          })}
        </Box>
      </Container>
    </Layout>
  );
};

export default Faq;
